import React, { Fragment } from 'react';

//layout components
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout(props) {
    let { children } = props;
    return (
        <Fragment>
            <Header />
            <Navbar {...props} />
            {children}
            <Footer />
        </Fragment>
    )
}